import { BackupSubscriptionTypes } from './backup-enums';

export class SubscriptionsFilter {
    enabled: boolean;
    subscriptionType: BackupSubscriptionTypes;
    searchString: string;
}
